import Bugsnag, { NotifiableError } from "@bugsnag/js";
import { useCallback, useEffect, useState } from "react";

import { useRootStore } from "store";
import { getTeamsContext, initTeams, loginTeamsPopup } from "common/teams";
import { setTabToken } from "common/MetaActions";
import config from "config/config";
import { Loader } from "components/loader/Loader";
import { captureEvent } from "components/posthog/customEventCapture";

import "../login/containers/LoginForm.scss";

//CAN THIS BE REMOVED?

export default function TeamsLogin() {
  const [failedMessage, setFailedMessage] = useState("");
  const [showLoginButton, setShowLoginButton] = useState(false);
  const { loginUser } = useRootStore((state) => state.user);

  const login = useCallback(async () => {
    await initTeams();
    try {
      const token = await loginTeamsPopup();
      setTabToken(token as string);
      loginUser(token as string);
    } catch (e) {
      switch (e) {
        case "CancelledByUser":
          setFailedMessage("Popup-rutan stängdes innan du loggades in.");
          break;
        case "FailedToOpenWindow":
          setShowLoginButton(true);
          break;
        default:
          setFailedMessage("Ett oväntat fel inträffade.");
      }
      Bugsnag.notify(e as NotifiableError);
    }
  }, [loginUser]);

  useEffect(() => {
    login();
  }, [login]);

  return (
    <div
      style={{
        textAlign: "center",
        padding: "3em",
        display: "flex"
      }}
    >
      {showLoginButton && (
        <button
          className="button"
          onClick={() => {
            login();
            captureEvent("Logga in");
          }}
        >
          Logga in
        </button>
      )}
      {!showLoginButton && !failedMessage && (
        <p>Logga in via popup-rutan som dyker upp strax.</p>
      )}
      {failedMessage && (
        <div>
          <p>{failedMessage}</p>
          <p>IT har fått en notis om felet.</p>
          <button
            className="button"
            onClick={() => {
              login();
              captureEvent("Försök igen");
            }}
          >
            Försök igen
          </button>
        </div>
      )}
    </div>
  );
}

export function TeamsLoginPopup() {
  const generateAzureUrl = (email: string) => {
    const urlParams = new URLSearchParams();
    const redirectUri = `${config.appUrl}/authenticate-internal-user`;

    urlParams.set("client_id", config.internalEntraClientId ?? "");
    urlParams.set("login_hint", email);
    urlParams.set("redirect_uri", redirectUri);
    urlParams.set("response_type", "code");

    return `https://login.microsoftonline.com/${
      config.azureTenantId
    }/oauth2/authorize?${urlParams.toString()}`;
  };

  useEffect(() => {
    (async () => {
      const context = await getTeamsContext();
      const azureUrl = generateAzureUrl(context.loginHint ?? "");
      window.location.href = azureUrl;
    })();
  });

  return (
    <div
      style={{
        minHeight: "50vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Loader
        style={{
          marginRight: ".25em"
        }}
      />{" "}
      <p>Loggar in...</p>
    </div>
  );
}
